import { MeasurableGroupType } from '@upright/common/model/input/measurable-group/types';
import { EmptyStateFundNoData } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/empty-state-fund-no-data';
import { GenericEmptyState } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/generic-empty-state';
import { useTargetsLensContext } from '@upright/ui/common/upright/core/impact-lenses/targets/common/use-targets-lens-context';

export function TargetsEmptyState() {
  const ctx = useTargetsLensContext();
  if (ctx?.data.groupType === MeasurableGroupType.FUND) {
    return <EmptyStateFundNoData message="This fund has not yet provided its targets to Upright." />;
  }
  return (
    <GenericEmptyState dataTitle="Impact targets" noDataMessage="This company has not provided its impact targets." />
  );
}
